import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { LinkBox, LinkBoxContent } from './LinkBox';

import { LegalTextGoogleFooter } from '../Stage/LegalText';

const ColoredBackground = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  overflow: 'hidden',
}));

const GridContainer = styled(Container)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(333px, 1fr))',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    gridGap: theme.spacing(3),
    '& a': {
      fontWeight: 500,
      '&:hover': {
        color: theme.palette.primary[400],
        textDecoration: 'none',
      },
    },
  },
}));

export interface LinkListProps {
  headline: string;
  subline: string;
  linkBoxes: LinkBoxContent[];
}

export function SEOLinkBoxes(props: LinkListProps) {
  const { headline, subline, linkBoxes } = props;
  return (
    <ColoredBackground>
      <Box
        sx={{
          my: 9,
        }}
      >
        <GridContainer>
          <div>
            <Typography
              variant="h2"
              suppressHydrationWarning
              sx={{
                mb: 2,
              }}
            >
              {headline}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
              }}
            >
              {subline}
            </Typography>
          </div>
          {linkBoxes.map((linkBoxItem, index) => (
            <LinkBox key={index} linkBoxContent={linkBoxItem} />
          ))}
        </GridContainer>
        <br />
        <LegalTextGoogleFooter showRadioText />
      </Box>
    </ColoredBackground>
  );
}
